<template>
	<div class="ReportBusinessView">
		<div class="content-menu">
			<div class="menu-item" :class="[current===index?'current':'']" v-for="(item,index) in menuList" :key="index"
				@click="handClick(index)">
				{{item.title}}
			</div>
			<div class="menu-border-top"></div>
			<div class="menu-border-bottom"></div>
			<div class="menu-border-1"></div>
			<div class="menu-border-2"></div>
			<div class="menu-border-3"></div>
			<div class="menu-border-4"></div>
		</div>
		<div class="content-view">
			<component :is="menuList[current].component" :auth="menuList[current].auth"></component>
		</div>
	</div>
</template>

<script>
	import companyBussi from './component/companyBussi.vue';
	import imsSales from './component/imsSales.vue';
	import channelBussi from './component/channelBussi.vue';
	import channelStock from './component/channelStock.vue';
	import termStatis from './component/termStatis.vue';
	export default {
		data() {
			return {
				current: 0,
				menuList: [],
			}
		},
		computed: {
			menusData() {
				return this.$store.state.MenusData.Menus;
			}
		},
		created() {
			this.setMenuList();
		},
		methods: {
			setMenuList() {
				let nodesIndex = this.menusData.filter(item => item.NodeID === '24')[0].Nodes.findIndex(item => item
					.NodeID == '157');
				let NodeInfo = this.menusData.filter(item => item.NodeID === '24')[0].Nodes[nodesIndex].Nodes.filter(
					item => item
					.NodeID === '139')[0].Nodes;
				this.menuList = NodeInfo.map(item => {
					item.title = item.NodeName;
					if (item.NodeID === '140') {
						item.component = companyBussi;
					}
					if (item.NodeID === '141') {
						item.component = imsSales;
					}
					if (item.NodeID === '142') {
						item.component = channelBussi;
					}
					if (item.NodeID === '143') {
						item.component = channelStock;
					}
					if (item.NodeID === '1058') {
						item.component = termStatis;
					}
					return item;
				})
			},
			handClick(index) {
				this.current = index;
			}
		}
	}
</script>

<style scoped lang="less">
	.ReportBusinessView {
		width: 100%;
		height: 100%;
		position: relative;

		.content-menu {
			display: flex;
			justify-content: space-around;
			align-items: center;
			user-select: none;
			cursor: pointer;
			background: #fff;
			padding: 24px 128px;
			box-shadow: inset 0px 8px 24px 0px rgba(27, 126, 242, 0.16);
			position: relative;

			.menu-item {
				width: 184px;
				height: 40px;
				line-height: 40px;
				text-align: center;
				box-sizing: border-box;
				font-size: 14px;
				font-family: Alibaba PuHuiTi 2.0-65 Medium, Alibaba PuHuiTi 20;
				font-weight: 400;
				color: #16181A;
				border: 1px solid #E6E8EB;
				background: url('../../../assets/report/menu-btn.png') no-repeat;
				background-size: 100% 100%;
			}

			.current {
				font-size: 14px;
				font-family: Alibaba PuHuiTi 2.0-65 Medium, Alibaba PuHuiTi 20;
				font-weight: 400;
				color: #FFFFFF;
				background: #00266D;
				border: 1px solid #00266D;
				background: url('../../../assets/report/menu-btn-current.png') no-repeat;
				background-size: 100% 100%;
			}

			.menu-border-1 {
				width: 12px;
				height: 12px;
				position: absolute;
				top: 0px;
				left: 0px;
				background: url('../../../assets/report/border-1.png') no-repeat;
				background-size: 100% 100%;
			}

			.menu-border-2 {
				width: 12px;
				height: 12px;
				position: absolute;
				top: 0px;
				right: 0px;
				background: url('../../../assets/report/border-2.png') no-repeat;
				background-size: 100% 100%;
			}

			.menu-border-3 {
				width: 12px;
				height: 12px;
				position: absolute;
				bottom: 0px;
				left: 0px;
				background: url('../../../assets/report/border-3.png') no-repeat;
				background-size: 100% 100%;
			}

			.menu-border-4 {
				width: 12px;
				height: 12px;
				position: absolute;
				bottom: 0px;
				right: 0px;
				background: url('../../../assets/report/border-4.png') no-repeat;
				background-size: 100% 100%;
			}

			.menu-border-top {
				width: 100%;
				height: 1px;
				position: absolute;
				top: 0px;
				left: 0px;
				background: linear-gradient(270deg, #FFFFFF 0%, #1B7EF2 49%, #FFFFFF 100%);
				background-size: 100% 100%;
			}

			.menu-border-bottom {
				width: 100%;
				height: 1px;
				position: absolute;
				bottom: 0px;
				left: 0px;
				background: linear-gradient(270deg, #FFFFFF 0%, #1B7EF2 49%, #FFFFFF 100%);
				background-size: 100% 100%;
			}
		}

		.content-view {
			margin-top: 16px;
		}
	}
</style>